import React from "react";
import ProductListButton from "../../../Button/ProductListButton";

const LocationUpdateButton = ({
  selectedProducts,
  userEditable,
  fields,
  currentProducts,
  setPendingChanges,
  user,
}) => {
  const locationFields = fields
    .filter((f) => f.type === "location")
    .map((f) => f.fields);

  const handleUpdateLocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        const newLocation = `${latitude},${longitude}`;
        const updated = [...currentProducts];

        selectedProducts.forEach((rowId) => {
          const rowIndex = updated.findIndex((p) => p._id === rowId);
          if (rowIndex !== -1) {
            locationFields.forEach((fieldName) => {
              const isEditable = user?.fieldsAccess?.includes(fieldName);
              if (!isEditable) return;

              updated[rowIndex][fieldName] = newLocation;

              setPendingChanges((prev) => ({
                ...prev,
                [rowId]: {
                  ...(prev[rowId] || {}),
                  [fieldName]: newLocation,
                },
              }));
            });
          }
        });
      },
      (err) => alert("Failed to get location: " + err.message)
    );
  };

  if (
    selectedProducts.length === 0 ||
    !locationFields.some((field) => userEditable.includes(field))
  ) {
    return null;
  }

  return (

      <ProductListButton
  onClick={handleUpdateLocation}
  icon="fas fa-map-marker-alt"
  label="Update Location"
/>

  );
};

export default LocationUpdateButton;
